import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewListActionButton } = listModuleLenses

export default (state, props) => {
	const { moduleId } = props
	return viewListActionButton(moduleId, moduleDescriptions)
}
